import Vue from "vue";
import Vuex from "vuex";
import apiVendor from "../services/VendorApiServices";
import router from '@/router/index';
import jwt_decode from "jwt-decode";
import TokenServices from "../services/TokenServices";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        access_token: localStorage.getItem('token'),
        refresh: localStorage.getItem('refresh'),
        remember_me: localStorage.getItem('remember'),
        user: {}
    },
    mutations: {
        updateStorage(state, { access_token, refresh, remember }) {
            TokenServices.updateLocalAccessToken(access_token, refresh, remember)
            state.access_token = access_token
            state.refresh = refresh

            let token = jwt_decode(state.access_token)
            let user_id = token.user_id
            Vue.prototype.$user_id = user_id
        },
        removeStorage(state) {
            TokenServices.removeToken()
            state.access_token = null
            state.refresh = null
        },
        setUserDetail(state, data) {
            state.user = data
        },
    },
    actions: {
        async login(context, credentials) {
            const data = new FormData()
            data.append('username', credentials.username)
            data.append('password', credentials.password)
            try{
                let login = (await axios.post(`${process.env.VUE_APP_VENDOR_BASE_URL}auth/login/`, data)).data.data
                context.commit('updateStorage', { access_token: login.access_token, refresh: login.refresh, remember: credentials.remember_me })
            }catch(error) {
                return Promise.reject(error);
            }
        },
        async logout(context) {
            const data = new FormData()
            data.append('refresh', localStorage.getItem('refresh'))
            
            try {
                await apiVendor.post("auth/logout/", data)
                context.commit('removeStorage')
                router.push({ name: 'Login' })
            } catch (error) {
                return Promise.reject(error);

            }
        },
        async refreshToken(context) {
            const data = new FormData()
            data.append('refresh', this.state.refresh)

            try {
                let refreshToken = await apiVendor.post("auth/refresh/", data)
                context.commit('updateStorage', { access_token: refreshToken.data.data.access_token, refresh: refreshToken.data.data.refresh })
            } catch (error) {
                return Promise.reject(error);

            }
        },
        async userDetail(context, user_id) {
            try {
                let user = (await apiVendor.get(`${user_id}/`)).data.data
                context.commit('setUserDetail', user)
            } catch (error) {
                return Promise.reject(error);
            }
        },
        tokenInvalid(context) {
            context.commit('removeStorage')
            router.push({ name: 'Login' })
        }
    },
    getters: {
        loggedIn(state) {
            return state.access_token != null
        },
        user(state) {
            return state.user
        },
        userFieldStatus(state) {
            return state.user.name == "" || state.user.pic == "" || state.user.phone == "" || state.user.country == ""
        },
        user_id() {
            const access_token = jwt_decode(localStorage.getItem('token'))
            return access_token.user_id
        }
    },
    modules: {},
});
